const CANONICAL_GUID_PATTERN =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/iu;

export function isCanonicalDocumentId(value: unknown): value is string {
    return typeof value === 'string' && CANONICAL_GUID_PATTERN.test(value);
}
